import { GetServerSidePropsContext, InferGetServerSidePropsType } from "next";
import { useTranslations } from "next-intl";

import Container from "~/components/common/container";
import Grid from "~/components/common/grid";
import CustomerCare from "~/components/customer-care/customer-care";
import LayoutPage from "~/components/layout/layout-page";
import SignUp from "~/components/sign-up/sign-up";
import { ActionCodeContextProvider } from "~/contexts/action-code-context-provider";
import { usePageTracking } from "~/contexts/page-trackings";
import styles from "~/styles/pages/sign-up.module.scss";
import ssrUtils from "~/utils/ssr-utils";

type Props = InferGetServerSidePropsType<typeof getServerSideProps>;

export default function SignUpPage(props: Props) {
  const t = useTranslations();
  usePageTracking("sign_up");

  return (
    <LayoutPage {...props} mainClasses={styles.pageBackground} navColor="white" hidePrefooter>
      <Container>
        <Grid>
          <div className={styles.containerSignUp}>
            <div className={styles.formWrapper}>
              <h1 className={styles.headline}>{t("generic.create_account")}</h1>
              <ActionCodeContextProvider>
                <SignUp />
              </ActionCodeContextProvider>
            </div>
          </div>
          <div className={styles.containerCustomerCare}>
            <CustomerCare />
          </div>
        </Grid>
      </Container>
    </LayoutPage>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const data = await ssrUtils.getServerSideData(context);
  return {
    props: {
      ...data,
    },
  };
}
